<template>
  <div id="app" :class="[browser.name, 'v' + browser.version.split('.')[0]]">
    <div class="main-wrapper">
      <router-view/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { USER_LOGOUT } from '@/store/actions.type'
import $ from 'jquery'

const { detect } = require('detect-browser')

export default {
  name: 'App',
  computed: {
    ...mapGetters(['currentOperator', 'isAuthenticated', 'isUserAuthenticated'])
  },
  data () {
    return {
    }
  },
  created: function () {
    this.browser = detect()
  },
  methods: {
    toggleNav () {
      $('body').toggleClass('burger-navigation-show')
    },
    logout () {
      this.$store.dispatch(USER_LOGOUT).then(() => {
        this.$router.push({ name: 'home' })
      })
    }
  }
}
</script>

<style type='text/css' lang='scss'>
  @import "assets/styles/main.scss";

  input.invalid {
    border-bottom-color: red;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  ul.error-messages {
    padding: 0;
    li {
      list-style-type: none;
      color: red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue